import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Contacto from '@/views/Contacto'
import Nosotros from '@/views/Nosotros'
import Servicio from '@/views/Servicios'
import Colision from '@/views/Colision'
import AutosNuevosChevrolet from '@/views/AutosNuevosChevrolet'
import AutosNuevosCadillac from '@/views/AutosNuevosCadillac'
import AutosUsadosChevrolet from '@/views/AutosUsadosChevrolet'
import AutosUsadosCadillac from '@/views/AutosUsadosCadillac'
import Description from '@/views/Description'
import PreOwnedDescription from '@/views/PreOwnedDescription'
import ProcesoFinanciamiento from '@/views/ProcesoFinanciamiento'
import SolicitudCredito from '@/views/SolicitudCredito'
import SolicitudCreditoDos from '@/views/solicitud-credito'
import Blog from '@/views/Blog'
import Article from '@/views/Article'
import Promociones from '@/views/Promociones'
import Financiamiento from '@/views/Financiamiento'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/nosotros',
    name: 'Nosotros',
    component: Nosotros
  },
  {
    path: '/servicio-certificado',
    name: 'Servicio',
    component: Servicio
  },
  {
    path: '/colision',
    name: 'colision',
    component: Colision
  },
  {
    path: '/autosnuevoschevrolet',
    name: 'AutosNuevosChevrolet',
    component: AutosNuevosChevrolet
  },
  {
    path: '/autosnuevoscadillac',
    name: 'AutosNuevosCadillac',
    component: AutosNuevosCadillac
  },
  {
    path: '/autos-semi-nuevos',
    name: 'AutosSeminuevosChevrolet',
    component: AutosUsadosChevrolet
  },
  {
    path: '/autosseminuevoscadillac',
    name: 'AutosSeminuevosCadillac',
    component: AutosUsadosCadillac
  },
  {
    path: '/description/:id',
    name: 'Description',
    component: Description
  },
  {
    path: '/autos-semi-nuevos/:id',
    name: 'PreOwnedDescription',
    component: PreOwnedDescription
  },
  {
    path: '/proceso_financiamiento/:id',
    name: 'ProcesoFinanciamiento',
    component: ProcesoFinanciamiento
  },
  {
    path: '/contacto',
    name: 'Contacto',
    component: Contacto
  },
  {
    path: '/promociones',
    name: 'Promociones',
    component: Promociones
  },
  {
    path: '/financiamiento',
    name: 'Financiamiento',
    component: Financiamiento
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/solicitud-credito',
    name: 'SolicitudCredito',
    component: SolicitudCredito
  },
  {
    path: '/solicitud-creditoL',
    name: 'SolicitudCreditodos',
    component: SolicitudCreditoDos
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog
  },
  {
    path: '/article/:id',
    name: 'Article',
    component: Article
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => { window.location.href = '/' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
